import apiClient from '@/services/api_client';

export async function eventCopyMessage(
    messageId: string,
    tenantId: string,
    messageContent: string,
    sessionId: string
) {
    const url = '/event/copy_message';
    const body = {
        message_id: messageId,
        tenant_id: tenantId,
        message_content: messageContent,
        session_id: sessionId
    };

    const response = await apiClient.post(url, body);
    return await response.json();
}

export async function eventExportMessage(
    messageId: string,
    tenantId: string,
    message_content: string,
    sessionId: string
) {
    const url = '/event/export_message';
    const body = {
        message_id: messageId,
        tenant_id: tenantId,
        message_content: message_content,
        session_id: sessionId
    };

    const response = await apiClient.post(url, body);
    return response;
}

export async function eventPresentationDownloadClicked(
    documentId: string,
    tenantId: string,
    isInTrial: boolean,
    slideCount?: number
) {
    const url = '/event/presentation_download_clicked';
    const body = {
        document_id: documentId,
        tenant_id: tenantId,
        is_in_trial: isInTrial,
        slide_count: slideCount
    };

    const response = await apiClient.post(url, body);
    return await response.json();
}
